import React, { useContext } from 'react'
import { ChangePresentContext, PostEventAnalysisContext } from '../SingleEvent'
import { TextField } from '@mui/material'

const PEASummary = () => {
  const { postEventAnalysis, setPostEventAnalysis } = useContext(
    PostEventAnalysisContext
  )
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <TextField
      multiline
      minRows={2}
      value={postEventAnalysis?.summary}
      onChange={(e) => {
        setPostEventAnalysis((prev) => ({
          ...prev,
          summary: e.target.value,
        }))
        !changesPresent && setChangesPresent(true)
      }}
      label="Summary of Event"
    />
  )
}

export default React.memo(PEASummary)
